import { edgeColourOf } from "../../../domain/productComposer/images";

const SAMPLE_SIZE = 64;

const loadImage = (src) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", reject);
    image.src = src;
  });

const sampledEdgeColour = (image) => {
  const canvas = document.createElement("canvas");
  canvas.width = SAMPLE_SIZE;
  canvas.height = SAMPLE_SIZE;
  const context = canvas.getContext("2d");
  context.drawImage(image, 0, 0, SAMPLE_SIZE, SAMPLE_SIZE);
  const { data } = context.getImageData(0, 0, SAMPLE_SIZE, SAMPLE_SIZE);

  return edgeColourOf({ data, width: SAMPLE_SIZE, height: SAMPLE_SIZE });
};

/* Browsers apply EXIF orientation when decoding into an <img>, so naturalWidth and
 * naturalHeight are already upright, matching what the server stores. */
export default async function readImage(src) {
  const image = await loadImage(src);

  return {
    natural: { width: image.naturalWidth, height: image.naturalHeight },
    edgeColour: sampledEdgeColour(image),
  };
}
